import React, { useEffect, useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "./AllDestinations.css";
import { getTopDestinations } from "../../api";
import CategoryContext from "../../context/CategoryContext";

const AllDestinations = () => {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.language === "ar";
  const [destinations, setDestinations] = useState([]);
  const { setSelectedCategoryId } = useContext(CategoryContext);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await getTopDestinations();
        const formattedData = data.map((dest) => ({
          ...dest,
          imageUrl: dest.Icon,
        }));
        setDestinations(formattedData);
      } catch (error) {
        console.error("Error fetching destinations:", error);
      }
    };
    fetchData();
  }, []);

  const handleCategoryClick = (CategoryID) => {
    setSelectedCategoryId(CategoryID);
    navigate(`/category/${CategoryID}`);
  };

  return (
    <main className={`all-destinations-page page container fade-up ${isRTL ? "rtl" : "ltr"}`} dir={isRTL ? "rtl" : "ltr"}>
      <section className="ad-section">
        <h1 className="ad-title">{t("All Categories", "All Categories")}</h1>

        <div className="ad-grid">
          {destinations.map((dest) => (
            <div
              key={dest.CategoryID}
              className="ad-card"
              onClick={() => handleCategoryClick(dest.CategoryID)}
              tabIndex={0}
              role="button"
              aria-label={t(dest.NameCategory)}
            >
              <div
                className="ad-image"
                style={{ backgroundImage: `url(${dest.imageUrl})` }}
              >
                <div className="ad-overlay">
                  <h2>{t(dest.NameCategory, dest.NameCategory)}</h2>
                </div>
              </div>
              <h3 className="ad-name">{t(dest.NameCategory, dest.NameCategory)}</h3>
            </div>
          ))}
        </div>
      </section>
    </main>
  );
};

export default AllDestinations;